/* eslint-disable eqeqeq */
import {
  Card,
  LinearProgress,
} from "@material-ui/core";
import axios from "axios";
import React, { Component } from "react";
import {
  Alert,
  Badge,
  Button,
  ButtonToolbar,
  Form,
  Modal,
  Table,
} from "react-bootstrap";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { NoticePengendalian, YearSelect } from "../../../../_metronic/_partials/controls";
import AppConfig from "../../../config/AppConfig";

class Pengendalian extends Component {
  constructor(props, context) {
    super(props, context);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.inputChange = this.inputChange.bind(this);
    this.showDetails = this.showDetails.bind(this);
    this.showHistorical = this.showHistorical.bind(this);
    this.modalEdit = this.modalEdit.bind(this);
  }
  state = {
    showDialogAdd: false,
    showDetails: false,
    modalEdit: false,
    loading: false,
    loading2: true,
    loading_details: true,
    get_ref: [],
    get_list: [],
    get_details: [],
    showHistorical: false,
    data_historical: [],
    loadingHistorical: false,
    // FORM
    id_pengendalian: [],
    id_pengaturan: [],
    nama: [],
    rtm: [],
    bukti_rtm: [],
    rtl: [],
    bukti_rtl: [],
    tautan: "",
    nama_bidang: "",
    deskripsi: "",
    check1: false,
    check2: true,
    check3: false,
    check4: true,
  };

  handleAdd() {
    this.setState({
      showDialogAdd: true,
    });
  }

  handleClose() {
    this.setState({
      showDialogAdd: false,
      showDetails: false,
      modalEdit: false,
      loading: false,
      nama: [],
      rtm: [],
      rtl: [],
      bukti_rtm: [],
      bukti_rtl: [],
      tautan: "",
      nama_bidang: "",
      deskripsi: "",
      check1: false,
      check2: true,
      check3: false,
      check4: true,
      showHistorical: false,
      data_historical: [],
      loadingHistorical: false,
    });
  }
  onInputChangePengaturan = (e, type) => {
    this.setState({
      [type]: e.target.value,
    });
  };

  inputChange = (e, type) => {
    if (e === 0) {
      this.setState({
        check1: true,
        check2: false,
      });
    } else if (e === 1) {
      this.setState({
        check1: false,
        check2: true,
      });
    }
    if (e === 2) {
      this.setState({
        check3: true,
        check4: false,
      });
    } else if (e === 3) {
      this.setState({
        check3: false,
        check4: true,
      });
    }
  };

  showDetails = (id) => {
    this.setState({ showDetails: true, loading_details: true });
    axios
      .get(AppConfig.DetailsPengendalian + id)
      .then((res) => {
        this.setState(
          {
            get_details: res.data.result.detail,
            loading_details: false,
          },
          () => {
            console.log(this.state.get_details);
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  showHistorical = (jenis) => {
    this.setState({ showHistorical: true });
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }

    let id_institusi = localStorage.getItem("id_sp_temp");
    if (id_institusi === undefined || id_institusi === null) {
      id_institusi = sessiondata.i_idunit;
    }
    let tahun_siklus = localStorage.getItem("tahun_siklus");
    axios
      .get(AppConfig.HistoryPengendalianSiklus + id_institusi + "/" + jenis + "/" + tahun_siklus + session)
      .then((res) => {
        this.setState({
          data_historical: res.data.result.data,
          loadingHistorical: true,
        });
      })
      .catch((err) => {
        this.setState({
          display_edit: false,
          showDialogFormSave: false,
        });
      });
  };
  handleSave = (e) => {
    swal({
      title: "Anda yakin?",
      text: "Pastikan verifikator dapat melihat dokumen yang Anda upload!",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willSave) => {
      if (willSave) {
        e.preventDefault();
        var formData = new FormData();
        this.setState({ loading: true });
        let userdata = JSON.parse(localStorage.getItem("userdata"));
        let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
        let session = "";
        if (userdata) {
          session =
            // "?token="+userdata.token+
            "?id_pengguna=" +
            userdata.id_pengguna +
            "&id_unit=" +
            sessiondata.i_idunit +
            "&id_role=" +
            sessiondata.i_idrole;
        }
        formData.append("data[id_sp]", sessiondata.i_idunit);
        // formData.append("data[id_jenis_aturan]", this.state.nama);
        // formData.append("data[nama_bidang]", this.state.nama_bidang);
        formData.append("data[deskripsi]", this.state.deskripsi);
        let session_tahun_siklus = localStorage.getItem("tahun_siklus")
        formData.append("data[tahun_siklus]", session_tahun_siklus);
        formData.append("data[tautan]", this.state.tautan);
        // formData.append("data[rtm]", this.state.rtm);
        // formData.append("data[rtl]", this.state.rtl);
        // formData.append("data[bukti_rtm]", this.state.bukti_rtm);
        // formData.append("data[bukti_rtl]", this.state.bukti_rtl);
        axios
          .post(AppConfig.SavePengendalian, formData)
          .then((res) => {
            this.setState(
              {
                loading: false,
              },
              () => {
                console.log(formData);
              }
            );
            swal({
              title: "Berhasil!",
              text: "pengaturan berhasil!",
              icon: "success",
              button: "OK!",
            });
            console.log(res);
            this.componentDidMount();
            this.handleClose();
          })
          .catch((err) => {
            swal({
              title: "Gagal!",
              text: "Pengaturan tidak berhasil disimpan!",
              icon: "error",
              button: "OK!",
            });
            console.log(err);
          });
      } else {
        swal("Anda telah membatalkan pengaturan!");
      }
    });
  };
  componentDidMount() {
    let id_institusi = localStorage.getItem("id_sp_temp");
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));

    let session_tahun_siklus = localStorage.getItem("tahun_siklus");
    let id_sp = sessiondata.i_idunit;
    if (id_institusi !== "") {
      id_sp = id_institusi;
    }
    if (id_institusi === null) {
      id_sp = sessiondata.i_idunit;
    }
    let session = "";
    if (this.props.idSp !== undefined) {
      id_sp = this.props.idSp;
    }
    if (id_sp) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        id_sp +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    axios
      .get(AppConfig.FormRefPengendalian)
      .then((res) => {
        this.setState({
          get_ref: res.data.result.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(AppConfig.ListPengendalianBySiklus + id_sp + "/" + session_tahun_siklus + session)
      .then((res) => {
        console.log("Daftar Pengendalian", res);
        this.setState({
          loading2: false,
          get_list: res.data.result.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  modalEdit = (id) => {
    this.setState({ modalEdit: true, loading_details: true });
    axios
      .get(AppConfig.DetailsPengendalian + id)
      .then((res) => {
        this.setState(
          {
            loading_details: false,
            get_details: res.data.result.detail,
            id_pengendalian: res.data.result.detail.id_pengendalian,
            id_pengaturan: res.data.result.detail.id_pengaturan,
            // nama: res.data.result.detail.id_jenis_aturan,
            // nama_bidang: res.data.result.detail.nama_bidang,
            deskripsi: res.data.result.detail.deskripsi,
            tautan: res.data.result.detail.tautan,
            // rtm: res.data.result.detail.rtm,
            // rtl: res.data.result.detail.rtl,
            // check1: res.data.result.detail.rtm !== null ? true : false,
            // check2: res.data.result.detail.rtm !== null ? false : true,
            // check3: res.data.result.detail.rtl !== null ? true : false,
            // check4: res.data.result.detail.rtl !== null ? false : true,
            // bukti_rtm:
            //   res.data.result.detail.bukti_rtm === "null"
            //     ? ""
            //     : res.data.result.detail.bukti_rtm,
            // bukti_rtl:
            //   res.data.result.detail.bukti_rtl === "null"
            //     ? ""
            //     : res.data.result.detail.bukti_rtl,
          },
          () => {
            console.log(res);
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleEdit = (e) => {
    swal({
      title: "Anda yakin?",
      text: "Pastikan verifikator dapat melihat dokumen yang Anda upload!",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willSave) => {
      if (willSave) {
        e.preventDefault();
        var formData = new FormData();
        this.setState({ loading: true });
        let userdata = JSON.parse(localStorage.getItem("userdata"));
        let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
        let session = "";
        if (userdata) {
          session =
            // "?token="+userdata.token+
            "?id_pengguna=" +
            userdata.id_pengguna +
            "&id_unit=" +
            sessiondata.i_idunit +
            "&id_role=" +
            sessiondata.i_idrole;
        }
        formData.append("data[id_sp]", sessiondata.i_idunit);
        formData.append("data[id_pengendalian]", this.state.id_pengendalian);
        formData.append("data[id_pengaturan]", this.state.id_pengaturan);
        // formData.append("data[rtm]", this.state.rtm);
        // formData.append("data[rtl]", this.state.rtl);
        // formData.append("data[id_jenis_aturan]", this.state.nama);
        // formData.append("data[nama_bidang]", this.state.nama_bidang);
        formData.append("data[deskripsi]", this.state.deskripsi);
        formData.append("data[tautan]", this.state.tautan);
        // formData.append("data[bukti_rtm]", this.state.bukti_rtm);
        // formData.append("data[bukti_rtl]", this.state.bukti_rtl);
        axios
          .post(AppConfig.SavePengendalian + session, formData)
          .then((res) => {
            this.setState({
              loading: false,
            });
            swal({
              title: "SUKSES!",
              text: "Pengaturan berhasil diubah!",
              icon: "success",
              button: "OK!",
            });
            console.log(res);
            this.componentDidMount();
            this.handleClose();
          })
          .catch((err) => {
            swal({
              title: "Gagal!",
              text: "Pengaturan tidak berhasil disimpan!",
              icon: "error",
              button: "OK!",
            });
            console.log(err);
          });
      } else {
        swal("Anda telah membatalkan pengaturan!");
      }
    });
  };

  handhandleShowHistorical = (jenis) => {
    // console.log(jenis);
    this.setState({ showHistorical: true });
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }

    let id_institusi = localStorage.getItem("id_sp_temp");
    if (id_institusi === undefined || id_institusi === null) {
      id_institusi = sessiondata.i_idunit;
    }
    let tahun_siklus = localStorage.getItem("tahun_siklus");
    axios
      .get(
        AppConfig.HistoryPengendalianSiklus + id_institusi + "/" + jenis + "/" + tahun_siklus + session
      )
      .then((res) => {
        console.log(res);
        this.setState({
          data_historical: res.data.result.data,
          loadingHistorical: true,
        });
      })
      .catch((err) => {
        console.log(err);
        // this.setState({
        //   display_edit: false,
        //   showDialogFormSave: false,
        // });
      });
  };

  handleDelete = (id) => {
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    swal({
      title: "Apakah anda yakin?",
      text: "Pengendalian akan dihapus",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        this.setState({ loading: true });
        axios
          .get(AppConfig.DeletePengendalian + id + session)
          .then((res) => {
            swal({
              title: "Berhasil!",
              text: "Pengendalian berhasil dihapus!",
              icon: "success",
              button: "OK!",
            });
            this.componentDidMount();
          })
          .catch((err) => {
            swal({
              title: "Gagal!",
              text: "Pengendalian gagal dihapus!",
              icon: "error",
              button: "OK!",
            });
          });
      }
    });
  };
  render() {
    let userdata = JSON.parse(localStorage.getItem("sessiondata"));
    let {
      loading,
      get_ref,
      get_list,
      check1,
      check2,
      check3,
      check4,
      nama,
      rtm,
      rtl,
      bukti_rtm,
      bukti_rtl,
      data_historical,
      tautan,
      nama_bidang,
      deskripsi,
    } = this.state;
    let i = 0;
    let result = [];
    if (get_ref !== undefined) {
      for (var key in get_ref) {
        result[i] = {
          result: get_ref[key],
        };
        i++;
      }
    }
    let ii = 0;
    let list_result = [];
    if (get_list !== undefined) {
      for (var key in get_list) {
        list_result[ii] = {
          result: get_list[key],
        };
        ii++;
      }
    }
    // console.log("get_list =", get_list)
    // console.log("get_details =", get_details)
    // console.log("rtm =", rtm)
    // console.log("rtl =", rtl)

    let display_historical = [];
    if (this.state.loadingHistorical === true) {
      data_historical.map((list, i) => {
        display_historical.push(
          <>
            <tr>
              <td style={{ textAlign: "left" }}>
                {list.nama_jenis !== "null" ? list.nama_jenis : "-"}
              </td>
              <td style={{ textAlign: "center" }}>
                {list.tautan === "null" ? (
                  "-"
                ) : (
                  <a target="_blank" className="menu-link" href={list.tautan}>
                    <Button
                      className="btn btn-icon btn-success btn-sm"
                      style={{ minWidth: "50px", borderRadius: "12px" }}
                    >
                      <i
                        class="flaticon-attachment"
                        style={{ color: "#ffffff", fontSize: "14px" }}
                      ></i>
                    </Button>
                  </a>
                )}
              </td>
              <td style={{ textAlign: "center" }}>
                {list.statusajuan === 3 ? (
                  <Badge
                    pill
                    variant="success"
                    style={{
                      backgroundColor: "#BEF2FF",
                      color: "#334443",
                      fontSize: "12px",
                    }}
                  >
                    <Badge variant="light">
                      {" "}
                      <span style={{ color: "#37bf30" }}>✔</span>
                    </Badge>
                    &nbsp;&nbsp;&nbsp; Terverifikasi
                  </Badge>
                ) : (
                  <Badge
                    pill
                    variant="secondary"
                    style={{
                      backgroundColor: "#BEF2FF",
                      color: "#334443",
                      fontSize: "12px",
                    }}
                  >
                    <Badge variant="light">
                      {" "}
                      <span style={{ color: "#858585" }}>•</span>
                    </Badge>
                    &nbsp;&nbsp;&nbsp; Belum Terverifikasi
                  </Badge>
                )}
              </td>
              <td style={{ textAlign: "center" }}>
                {list.tanggal_penetapan === "null" ? (
                  "-"
                ) : (
                  <Moment
                    format="DD/MM/YYYY"
                    date={
                      list.tanggal_penetapan === "null"
                        ? "-"
                        : list.tanggal_penetapan
                    }
                  />
                )}
              </td>
              <td style={{ textAlign: "left" }}>
                {list.deskripsi !== "null" ? list.deskripsi : "-"}
              </td>
            </tr>
          </>
        );
      });
    } else {
      display_historical = (
        <>
          <tr>
            <td colSpan="5">
              <LinearProgress color="secondary" variant="query" />
            </td>
          </tr>
        </>
      );
    }
    return (
      console.log(userdata),
      (
        <>
          <NoticePengendalian
            svg="/media/svg/icons/Home/Building.svg"
            style={{ marginBottom: "0px", boxShadow: "none" }}
          >
            <div className="d-flex align-items-center justify-content-between w-100">
              <div>
                <strong style={{ fontSize: "18px" }}>Pengendalian</strong>
                <p className="mb-0">Pengendalian standar dalam SPMI Institusi</p>
              </div>
              <div>
                <YearSelect />
              </div>
            </div>
          </NoticePengendalian>
          <br />
          <Card style={{ padding: "2%" }}>
            {userdata.i_idrole === 3 ? (
              <div className="row" style={{ marginBottom: "20px" }}>
                <div className="col-md-12">
                  <div style={{ float: "right" }}>
                    <ButtonToolbar>
                      <span className="svg-icon svg-icon-2x svg-icon-white">
                        <Button variant="primary" onClick={this.handleAdd}>
                          <i
                            class="flaticon-add"
                            style={{ color: "#ffffff", fontSize: "14px" }}
                          ></i>
                          &nbsp; Tambahkan Pengendalian Baru
                        </Button>
                      </span>
                    </ButtonToolbar>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            <Table responsive style={{ overflow: "auto" }}>
              <thead
                className="text-white"
                style={{ backgroundColor: "#3047ad" }}
              >
                <tr>
                  <th
                    style={{
                      fontSize: "12px",
                      textTransform: "uppercase",
                      verticalAlign: "middle",
                    }}
                  >
                    Deskripsi
                  </th>
                  <th
                    className="text-center"
                    style={{
                      fontSize: "12px",
                      textTransform: "uppercase",
                      verticalAlign: "middle",
                    }}
                  >
                    Tautan
                  </th>
                  <th
                    className="text-center"
                    style={{
                      fontSize: "12px",
                      textTransform: "uppercase",
                      verticalAlign: "middle",
                    }}
                  >
                    Status Verifikasi
                  </th>
                  <th
                    className="text-center"
                    style={{
                      fontSize: "12px",
                      textTransform: "uppercase",
                      verticalAlign: "middle",
                    }}
                  >
                    Status Dokumen
                  </th>
                  <th
                    className="text-center"
                    style={{
                      fontSize: "12px",
                      textTransform: "uppercase",
                      verticalAlign: "middle",
                    }}
                  >
                    Aksi
                  </th>
                </tr>
              </thead>
              <tbody>
                {this.state.loading2 === true ? (
                  <tr>
                    <td colSpan="7">
                      <LinearProgress color="secondary" variant="query" />
                    </td>
                  </tr>
                ) : list_result.length > 0 ? (
                  list_result.map((list, i) => (
                    <tr>
                      <td style={{ textAlign: "", verticalAlign: "middle" }}>
                        {list.result.deskripsi}
                      </td>
                      <td className="text-center">
                        {list.result.tautan !== "null" ? (
                          <Button
                            href={list.result.tautan}
                            target="_blank"
                            className="btn btn-icon btn-light btn-sm"
                            style={{
                              minWidth: "50px",
                              borderRadius: "12px",
                              background: "#A9C6DE",
                            }}
                          >
                            <i
                              class="flaticon-attachment"
                              style={{ color: "#3F4254", fontSize: "14px" }}
                            ></i>
                          </Button>
                        ) : (
                          ""
                        )}

                        {list.result.rtl !== "null" ? (
                          <Button
                            href={list.result.rtl}
                            target="_blank"
                            className="btn btn-icon btn-light btn-sm"
                            style={{
                              minWidth: "50px",
                              borderRadius: "12px",
                              background: "#A9C6DE",
                            }}
                          >
                            RTL
                          </Button>
                        ) : (
                          ""
                        )}

                        {list.result.rtm !== "null" ? (
                          <Button
                            href={list.result.rtm}
                            target="_blank"
                            className="btn btn-icon btn-light btn-sm"
                            style={{
                              minWidth: "50px",
                              borderRadius: "12px",
                              background: "#A9C6DE",
                            }}
                          >
                            RTM
                          </Button>
                        ) : (
                          ""
                        )}
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          fontSize: "12px",
                          verticalAlign: "middle",
                        }}
                      >
                        {list.result.statusajuan === 3 ? (
                          <Badge
                            pill
                            variant="success"
                            style={{
                              backgroundColor: "#BEF2FF",
                              color: "#334443",
                              fontSize: "12px",
                            }}
                          >
                            <Badge variant="light">
                              {" "}
                              <span style={{ color: "#37bf30" }}>✔</span>
                            </Badge>
                            &nbsp;&nbsp;&nbsp; Terverifikasi
                          </Badge>
                        ) : (
                          <Badge
                            pill
                            variant="secondary"
                            style={{
                              backgroundColor: "#BEF2FF",
                              color: "#334443",
                              fontSize: "12px",
                            }}
                          >
                            Belum Terverifikasi
                          </Badge>
                        )}
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          fontSize: "12px",
                          verticalAlign: "middle",
                        }}
                      >
                        {list.result.dokumen_valid === "1" ? (
                          <Badge
                            pill
                            variant="success"
                            style={{
                              backgroundColor: "#BEF2FF",
                              color: "#334443",
                              fontSize: "12px",
                            }}
                          >
                            <Badge variant="light">
                              {" "}
                              <span style={{ color: "#37bf30" }}>✔</span>
                            </Badge>
                            &nbsp;&nbsp;&nbsp; Sudah Valid
                          </Badge>
                        ) : list.result.dokumen_valid === "0" ? (
                          <Badge
                            pill
                            variant="warning"
                            style={{
                              color: "#334443",
                              fontSize: "12px",
                            }}
                          >
                            Belum Valid
                          </Badge>
                        ) : (
                          <Badge
                            pill
                            variant="secondary"
                            style={{
                              backgroundColor: "#CCCCCC",
                              color: "#FFFFFF",
                            }}
                          >
                            Dokumen belum diverifikasi
                          </Badge>
                        )}
                      </td>
                      <td className="text-center">
                        {/* <Button
                        onClick={() =>
                          this.showHistorical(list.result.id_jenis_aturan)
                        }
                        className="btn btn-icon btn-success btn-sm"
                        style={{
                          minWidth: "50px",
                          marginRight: "10px",
                          borderRadius: "12px",
                        }}
                      >
                        <i
                          class="flaticon2-time"
                          style={{ fontSize: "14px" }}
                        ></i>
                      </Button> */}

                        {/* <Button
                          onClick={() =>
                            this.showDetails(list.result.id_pengendalian)
                          }
                          className="btn btn-icon  btn-secondary btn-sm"
                          style={{
                            minWidth: "50px",
                            borderRadius: "12px",
                          }}
                        >
                          <i
                            class="flaticon-info"
                            style={{ fontSize: "14px" }}
                          ></i>
                        </Button> */}
                        {userdata.i_idrole === 3 ||
                          userdata.i_idrole === 10 ||
                          userdata.i_idrole === 2013 ||
                          userdata.i_idrole === 2014 ? (
                          <Link
                            to={
                              "/ajuan-pengendalian/detail/" +
                              list.result.id_pengendalian
                            }
                          >
                            <Button
                              className="btn btn-icon btn-primary btn-sm"
                              style={{
                                minWidth: "50px",
                                marginLeft: "5px",
                                borderRadius: "12px",
                              }}
                            >
                              <i
                                class="flaticon-eye"
                                style={{ color: "#ffffff", fontSize: "14px" }}
                              ></i>
                            </Button>
                          </Link>
                        ) : (
                          ""
                        )}
                        {userdata.i_idrole === 3 ? (
                          <>
                            {
                              list.result.statusajuan === "null" || (list.result.dokumen_valid === "0" || list.result.dokumen_valid === "null") ? <Button
                                onClick={() =>
                                  this.modalEdit(list.result.id_pengendalian)
                                }
                                className="btn btn-icon btn-warning btn-sm"
                                style={{
                                  minWidth: "50px",
                                  marginLeft: "5px",
                                  margintight: "5px",
                                  borderRadius: "12px",
                                }}
                              >
                                <i
                                  class="flaticon-edit"
                                  style={{ fontSize: "14px" }}
                                ></i>
                              </Button> : ("")
                            }
                            {
                              (list.result.statusajuan === "null" || list.result.statusajuan === 1) && (list.result.dokumen_valid === "0" || list.result.dokumen_valid === "null") ?
                                <Button
                                  onClick={() =>
                                    this.handleDelete(list.result.id_pengendalian)
                                  }
                                  className="btn btn-icon btn-danger btn-sm"
                                  style={{
                                    minWidth: "50px",
                                    marginLeft: "5px",
                                    borderRadius: "12px",
                                  }}
                                >
                                  <i
                                    class="flaticon-delete"
                                    style={{ fontSize: "14px" }}
                                  ></i>
                                </Button>
                                : ("")}
                          </>
                        ) : (
                          ""
                        )}

                        <Button
                          onClick={() =>
                            this.handhandleShowHistorical(
                              list.result.id_jenis_aturan
                            )
                          }
                          className="btn btn-icon btn-success btn-sm"
                          style={{
                            minWidth: "50px",
                            borderRadius: "12px",
                            marginLeft: "5px",
                          }}
                        >
                          <i
                            class="flaticon2-time"
                            style={{ color: "#ffffff", fontSize: "14px" }}
                          ></i>
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <>
                    <td colSpan="5" style={{ textAlign: "center" }}>
                      <em>Data does not exist</em>
                    </td>
                  </>
                )}
              </tbody>
            </Table>
          </Card>

          {/* MODAL ADD */}
          <Modal
            size="lg"
            show={this.state.showDialogAdd}
            onHide={this.handleClose}
          >
            <Modal.Header closeButton>
              <Modal.Title>Tambahkan Pengendalian Baru</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {/* <Form.Label>Bidang Pengaturan standar</Form.Label>
              <Form.Control
                size="lg"
                type="text"
                name="nama_bidang"
                placeholder="Nama bidang pengaturan standar"
                value={nama_bidang}
                onChange={(e) => this.onInputChangePengaturan(e, "nama_bidang")}
              /> */}
              {/* <Form.Control
                as="select"
                value={nama}
                onChange={(e) => this.onInputChangePengaturan(e, "nama")}
              >
                <option value="">-Pilih nama bidang-</option>
                {result.map((list, i) => (
                  <option value={list.result.id_jenis_aturan}>
                    {list.result.nama_jenis}
                  </option>
                ))}
              </Form.Control> */}
              <Form.Label>
                Tautan laporan pelaksanaan dan hasil pengendalian
              </Form.Label>
              <Form.Control
                size="lg"
                type="text"
                name="tautan"
                placeholder="https:// ...."
                value={tautan}
                onChange={(e) => this.onInputChangePengaturan(e, "tautan")}
              />
              <br />
              <Form.Label htmlFor="input-with-icon-adornment">
                Deskripsi <small>*jika ada</small>{" "}
              </Form.Label>
              <Form.Control
                size="lg"
                type="text"
                as="textarea"
                placeholder="Deskripsi"
                value={deskripsi !== "null" ? deskripsi : "-"}
                onChange={(e) => this.onInputChangePengaturan(e, "deskripsi")}
              />
              {/* <br />
              <Form.Label>
                Apakah ada tautan RTM <em>(Rapat Tinjau Manajemen)</em> ?
              </Form.Label>
              <p>
                <FormControlLabel
                  control={
                    <Radio
                      name="rtm"
                      checked={check1}
                      onChange={(e) => this.inputChange(0, "rtm")}
                      value="Ada"
                      color="secondary"
                    />
                  }
                  label="Ada"
                />
                <FormControlLabel
                  control={
                    <Radio
                      name="rtm"
                      checked={check2}
                      onChange={(e) => this.inputChange(1, "rtm")}
                      value="Tidak Ada"
                      color="secondary"
                    />
                  }
                  label="Tidak Ada"
                />
              </p>
              {check1 === true ? (
                <>
                  <Form.Label>Masukkan tautan Pelaksanaan RTM : </Form.Label>
                  <Form.Control
                    size="lg"
                    type="text"
                    name="keterangan"
                    placeholder="https:// ...."
                    value={rtm}
                    onChange={(e) => this.onInputChangePengaturan(e, "rtm")}
                  />
                  <br />
                  <Form.Label>
                    Masukkan tautan bukti Pelaksanaan RTM :{" "}
                  </Form.Label>
                  <Form.Control
                    size="lg"
                    type="text"
                    name="keterangan"
                    placeholder="https:// ...."
                    value={bukti_rtm}
                    onChange={(e) =>
                      this.onInputChangePengaturan(e, "bukti_rtm")
                    }
                  />
                </>
              ) : (
                ""
              )}
              <br />
              <Form.Label>
                Apakah ada tautan RTL <em>(Rencana Tindak Lanjut)</em> ?
              </Form.Label>
              <p>
                <FormControlLabel
                  control={
                    <Radio
                      name="rtl"
                      checked={check3}
                      onChange={(e) => this.inputChange(2, "rtl")}
                      value="Ada"
                      color="secondary"
                    />
                  }
                  label="Ada"
                />
                <FormControlLabel
                  control={
                    <Radio
                      name="rtl"
                      checked={check4}
                      onChange={(e) => this.inputChange(3, "rtl")}
                      value="Tidak Ada"
                      color="secondary"
                    />
                  }
                  label="Tidak Ada"
                />
              </p>
              {check3 === true ? (
                <>
                  <Form.Label>Masukkan tautan Pelaksanaan RTL : </Form.Label>
                  <Form.Control
                    size="lg"
                    type="text"
                    name="keterangan"
                    placeholder="https:// ...."
                    value={rtl}
                    onChange={(e) => this.onInputChangePengaturan(e, "rtl")}
                  />
                  <br />
                  <Form.Label>
                    Masukkan tautan bukti Pelaksanaan RTL :{" "}
                  </Form.Label>
                  <Form.Control
                    size="lg"
                    type="text"
                    name="keterangan"
                    placeholder="https:// ...."
                    value={bukti_rtl}
                    onChange={(e) =>
                      this.onInputChangePengaturan(e, "bukti_rtl")
                    }
                  />
                </>
              ) : (
                ""
              )} */}
              <div
                style={{
                  textAlign: "center",
                  padding: "10px",
                  marginTop: "15px",
                  marginRight: "20px",
                  marginLeft: "20px",
                }}
              >
                <Alert variant="warning">
                  <b>
                    *Catatan: Pastikan link/tautan yang diberikan dapat
                    diakses/dibaca oleh publik!
                  </b>
                  <br />
                  (General Access : Anyone With The Link)
                </Alert>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <div style={{ textAlign: "right" }}>
                <Button
                  onClick={this.handleSave}
                  disabled={loading}
                  style={{
                    marginRight: "1vw",
                    backgroundColor: "#2061e3",
                    color: "white",
                  }}
                  variant="primary"
                >
                  SIMPAN
                  {loading && <i className="ml-3 spinner spinner-white"></i>}
                  &nbsp;&nbsp;
                </Button>
              </div>
              <Button variant="secondary" onClick={this.handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          {/* EDIT */}
          <Modal
            size="lg"
            show={this.state.modalEdit}
            onHide={this.handleClose}
          >
            <Modal.Header closeButton>
              <Modal.Title>Edit Bentuk Pengendalian</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {this.state.loading_details === true ? (
                <>
                  <div className="row">
                    <div className="col-md-12">
                      <LinearProgress color="secondary" variant="query" />
                    </div>
                  </div>
                </>
              ) : (
                <>
                  {/* <Form.Label>Bidang Pengaturan standar</Form.Label>
                  <Form.Control
                    size="lg"
                    type="text"
                    name="nama_bidang"
                    placeholder="Nama bidang pengaturan standar"
                    value={nama_bidang}
                    onChange={(e) =>
                      this.onInputChangePengaturan(e, "nama_bidang")
                    }
                  /> */}
                  {/* <Form.Control
                    as="select"
                    value={nama}
                    onChange={(e) => this.onInputChangePengaturan(e, "nama")}
                  >
                    <option value="">-Pilih nama bidang-</option>
                    {result.map((list, i) => (
                      <option value={list.result.id_jenis_aturan}>
                        {list.result.nama_jenis}
                      </option>
                    ))}
                  </Form.Control> */}
                  <Form.Label>
                    Tautan laporan pelaksanaan dan hasil pengendalian
                  </Form.Label>
                  <Form.Control
                    size="lg"
                    type="text"
                    name="tautan"
                    placeholder="https:// ...."
                    value={tautan}
                    onChange={(e) => this.onInputChangePengaturan(e, "tautan")}
                  />
                  <br />
                  <Form.Label htmlFor="input-with-icon-adornment">
                    Deskripsi <small>*jika ada</small>{" "}
                  </Form.Label>
                  <Form.Control
                    size="lg"
                    type="text"
                    as="textarea"
                    placeholder="Deskripsi"
                    value={deskripsi !== "null" ? deskripsi : "-"}
                    onChange={(e) => this.onInputChangePengaturan(e, "deskripsi")}
                  />
                  {/* <br />
                  <Form.Label>
                    Apakah ada tautan RTM <em>(Rapat Tinjau Manajemen)</em> ?
                  </Form.Label>
                  <p>
                    <FormControlLabel
                      control={
                        <Radio
                          name="rtm"
                          checked={check1}
                          onChange={(e) => this.inputChange(0, "rtm")}
                          value="Ada"
                          color="secondary"
                        />
                      }
                      label="Ada"
                    />
                    <FormControlLabel
                      control={
                        <Radio
                          name="rtm"
                          checked={check2}
                          onChange={(e) => this.inputChange(1, "rtm")}
                          value="Tidak Ada"
                          color="secondary"
                        />
                      }
                      label="Tidak Ada"
                    />
                  </p>
                  {check1 === true ? (
                    <>
                      <Form.Label>
                        Masukkan tautan Pelaksanaan RTM :{" "}
                      </Form.Label>
                      <Form.Control
                        size="lg"
                        type="text"
                        name="keterangan"
                        placeholder="https:// ...."
                        value={rtm}
                        onChange={(e) => this.onInputChangePengaturan(e, "rtm")}
                      />
                      <Form.Label style={{ marginTop: "15px" }}>
                        Bukti Pelaksanaan RTM :{" "}
                      </Form.Label>
                      <Form.Control
                        size="lg"
                        type="text"
                        name="keterangan"
                        placeholder="https:// ...."
                        value={bukti_rtm}
                        onChange={(e) =>
                          this.onInputChangePengaturan(e, "bukti_rtm")
                        }
                      />
                    </>
                  ) : (
                    ""
                  )}
                  <br />
                  <Form.Label>
                    Apakah ada tautan RTL <em>(Rencana Tindak Lanjut)</em> ?
                  </Form.Label>
                  <p>
                    <FormControlLabel
                      control={
                        <Radio
                          name="rtl"
                          checked={check3}
                          onChange={(e) => this.inputChange(2, "rtl")}
                          value="Ada"
                          color="secondary"
                        />
                      }
                      label="Ada"
                    />
                    <FormControlLabel
                      control={
                        <Radio
                          name="rtl"
                          checked={check4}
                          onChange={(e) => this.inputChange(3, "rtl")}
                          value="Tidak Ada"
                          color="secondary"
                        />
                      }
                      label="Tidak Ada"
                    />
                  </p>
                  {check3 === true ? (
                    <>
                      <Form.Label>
                        Masukkan tautan Pelaksanaan RTM :{" "}
                      </Form.Label>
                      <Form.Control
                        size="lg"
                        type="text"
                        name="keterangan"
                        placeholder="https:// ...."
                        value={rtl}
                        onChange={(e) => this.onInputChangePengaturan(e, "rtl")}
                      />
                      <Form.Label style={{ marginTop: "15px" }}>
                        Bukti Pelaksanaan RTL :{" "}
                      </Form.Label>
                      <Form.Control
                        size="lg"
                        type="text"
                        name="keterangan"
                        placeholder="https:// ...."
                        value={bukti_rtl}
                        onChange={(e) =>
                          this.onInputChangePengaturan(e, "bukti_rtl")
                        }
                      />
                    </>
                  ) : (
                    ""
                  )} */}
                  <div
                    style={{
                      textAlign: "center",
                      padding: "10px",
                      marginTop: "15px",
                      marginRight: "20px",
                      marginLeft: "20px",
                    }}
                  >
                    <Alert variant="warning">
                      <b>
                        *Catatan: Pastikan link/tautan yang diberikan dapat
                        diakses/dibaca oleh publik!
                      </b>
                      <br />
                      (General Access : Anyone With The Link)
                    </Alert>
                  </div>
                </>
              )}
            </Modal.Body>
            <Modal.Footer>
              <div style={{ textAlign: "right" }}>
                <Button
                  onClick={this.handleEdit}
                  disabled={loading}
                  style={{
                    marginRight: "1vw",
                    backgroundColor: "#2061e3",
                    color: "white",
                  }}
                  variant="primary"
                >
                  SIMPAN
                  {loading && <i className="ml-3 spinner spinner-white"></i>}
                  &nbsp;&nbsp;
                </Button>
              </div>
              <Button variant="secondary" onClick={this.handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          {/* SHOW DETAILS */}
          <Modal
            size="lg"
            show={this.state.showDetails}
            onHide={this.handleClose}
          >
            <Modal.Header closeButton>
              <Modal.Title>Details Pengendalian</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {this.state.loading_details === true ? (
                <>
                  <div className="row">
                    <div className="col-md-12">
                      <LinearProgress color="secondary" variant="query" />
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="row row-paddingless">
                    <div className="col-md-4">
                      <strong>Bidang Pengaturan standar :</strong>
                    </div>
                    <div className="col-md-8">
                      {this.state.get_details.nama_jenis}
                    </div>
                  </div>
                  <hr />
                  <div className="row row-paddingless">
                    <div className="col-md-4">
                      <strong>Tautan RTM (Rapat Tinjau Manajemen) :</strong>
                    </div>
                    <div className="col-md-7">{this.state.get_details.rtm}</div>
                    <div className="col-md-1">
                      <Button
                        href={this.state.get_details.rtm}
                        target="_blank"
                        className="btn btn-icon btn-light btn-sm"
                        style={{
                          minWidth: "50px",
                          borderRadius: "12px",
                          background: "#A9C6DE",
                        }}
                      >
                        <i
                          class="flaticon-attachment"
                          style={{ color: "#3F4254", fontSize: "14px" }}
                        ></i>
                      </Button>
                    </div>
                  </div>
                  <hr />
                  <div className="row row-paddingless">
                    <div className="col-md-4">
                      <strong>Bukti Pelaksanaan RTM :</strong>
                    </div>
                    <div className="col-md-7">
                      {this.state.get_details.bukti_rtm !== "null"
                        ? this.state.get_details.bukti_rtm
                        : "-"}
                    </div>
                    <div className="col-md-1">
                      {this.state.get_details.bukti_rtm !== "null" ? (
                        <>
                          <Button
                            href={this.state.get_details.bukti_rtm}
                            target="_blank"
                            className="btn btn-icon btn-light btn-sm"
                            style={{
                              minWidth: "50px",
                              borderRadius: "12px",
                              background: "#A9C6DE",
                            }}
                          >
                            <i
                              class="flaticon-attachment"
                              style={{ color: "#3F4254", fontSize: "14px" }}
                            ></i>
                          </Button>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <hr />
                  <div className="row row-paddingless">
                    <div className="col-md-4">
                      <strong>Tautan RTL (Rencana Tindak Lanjut) :</strong>
                    </div>
                    <div className="col-md-7">{this.state.get_details.rtl}</div>
                    <div className="col-md-1">
                      <Button
                        href={this.state.get_details.rtl}
                        target="_blank"
                        className="btn btn-icon btn-light btn-sm"
                        style={{
                          minWidth: "50px",
                          borderRadius: "12px",
                          background: "#A9C6DE",
                        }}
                      >
                        <i
                          class="flaticon-attachment"
                          style={{ color: "#3F4254", fontSize: "14px" }}
                        ></i>
                      </Button>
                    </div>
                  </div>
                  <hr />
                  <div className="row row-paddingless">
                    <div className="col-md-4">
                      <strong>Bukti Pelaksanaan RTL :</strong>
                    </div>
                    <div className="col-md-7">
                      {this.state.get_details.bukti_rtl !== "null"
                        ? this.state.get_details.bukti_rtl
                        : "-"}
                    </div>
                    <div className="col-md-1">
                      {this.state.get_details.bukti_rtl !== "null" ? (
                        <>
                          <Button
                            href={this.state.get_details.bukti_rtl}
                            target="_blank"
                            className="btn btn-icon btn-light btn-sm"
                            style={{
                              minWidth: "50px",
                              borderRadius: "12px",
                              background: "#A9C6DE",
                            }}
                          >
                            <i
                              class="flaticon-attachment"
                              style={{ color: "#3F4254", fontSize: "14px" }}
                            ></i>
                          </Button>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            size="lg"
            show={this.state.showHistorical}
            onHide={this.handleClose}
          >
            <Modal.Header closeButton>
              <Modal.Title>Riwayat Pengaturan Pengendalian</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Table responsive style={{ overflow: "auto" }}>
                <thead
                  className="text-white"
                  style={{ backgroundColor: "#3047ad" }}
                >
                  <th style={{ textAlign: "center" }}>Nama Bidang</th>
                  <th style={{ textAlign: "center" }}>Tautan</th>
                  <th style={{ textAlign: "center" }}>Status Verfikasi</th>
                  <th style={{ textAlign: "center" }}>Tanggal Penetapan</th>
                  <th style={{ textAlign: "center" }}>Deskripsi</th>
                </thead>
                <tbody>{display_historical}</tbody>
              </Table>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      )
    );
  }
}
export default Pengendalian;
